/**
 * Detects whether the current user is likely in Sweden, so we can offer
 * Swish as the primary payment method automatically.
 *
 * Detection signals (any match → Swedish):
 *   1. Timezone = Europe/Stockholm
 *   2. Browser locale starts with 'sv' (Swedish)
 */
import { useEffect, useState } from 'react';

export function useIsSwedishUser(): boolean {
  // Starts false (SSR-safe — matches the server, which has no Intl/navigator
  // locale to check) and is only set true post-mount. The old useMemo ran
  // during render itself, so the server always computed `false` while the
  // client's first hydration render computed the real value immediately —
  // a hydration mismatch on every payment/download CTA for Swedish visitors.
  const [isSwedish, setIsSwedish] = useState(false);
  useEffect(() => {
    try {
      const tz   = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const lang = (navigator.language || (navigator.languages?.[0]) || '').toLowerCase();
      if (tz === 'Europe/Stockholm' || lang.startsWith('sv')) setIsSwedish(true);
    } catch { /* ignore */ }
  }, []);
  return isSwedish;
}
